var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmarkGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.117,
    height: 25.117,
    viewBox: "0 0 25.117 25.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9853a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#7f62ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6fb1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-195 -1628.883)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(199.883 1628.883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20.234V20.234H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0A12.5,12.5,0,1,1,0,12.5,12.5,12.5,0,0,1,12.5,0Z",
    transform: "translate(197 1626)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.123,14.51,4.607,10.994l-1.2,1.189L8.123,16.9,18.24,6.779,17.051,5.59Z",
    transform: "translate(199.348 1628.006)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGradient);
export default __webpack_public_path__ + "static/media/checkmark-gradient.a7d05da0fbdd63f2f1682ae3866f4063.svg";
export { ForwardRef as ReactComponent };